export function getVibeProfileSlug({user}) {
    // Prefer Vibe username slug, then fall back to id, otherwise empty string
    return user?.vibe?.username || user?.id || '';
}

export default getVibeProfileSlug;


